/**
 * Secondary Navigation Handler Module
 * Shows navigation as soon as the user starts scrolling
 */

const handleNavSecondary = () => {
	const nav = document.querySelector('.js-nav-secondary');

	if (!nav) {
		return;
	}

	const handleScroll = () => {
		const scroll = window.scrollY;

		if (scroll > 0) {
			nav.classList.add('is-active');
		} else {
			nav.classList.remove('is-active');
		}
	};

	// Add event listeners
	window.addEventListener('load', handleScroll);
	window.addEventListener('scroll', handleScroll, { passive: true });
};

export default handleNavSecondary;
